<script setup lang="ts">
import type {InvokedTool} from '@/client/mentor/MessagesClient'
import DebugBadge from '@/components/assistant/chat/message/DebugBadge.vue'

defineProps<{
  tools?: InvokedTool[] | null
}>()

const toolBadgeClasses = [
  'bg-sky-50 text-sky-700 border-sky-200',
  'bg-emerald-50 text-emerald-700 border-emerald-200',
  'bg-amber-50 text-amber-700 border-amber-200',
  'bg-rose-50 text-rose-700 border-rose-200',
  'bg-violet-50 text-violet-700 border-violet-200',
]

function getToolBadgeClass(toolName: string): string {
  const hash = toolName.split('').reduce((sum, character) => sum + character.charCodeAt(0), 0)
  return toolBadgeClasses[hash % toolBadgeClasses.length]
}

function formatInvokedTool(tool: InvokedTool): string {
  try {
    const args = JSON.parse(tool.arguments)
    const result = tool.result != null ? JSON.parse(tool.result) : null
    return JSON.stringify({arguments: args, result}, null, 2)
  } catch {
    return `arguments: ${tool.arguments}\nresult: ${tool.result ?? 'null'}`
  }
}
</script>

<template>
  <div v-if="tools?.length" class="flex flex-wrap gap-1.5 pt-0.5">
    <DebugBadge
      v-for="(tool, toolIndex) in tools"
      :key="`${tool.toolName}-${toolIndex}`"
      :badge-class="getToolBadgeClass(tool.toolName)"
    >
      {{ tool.toolName }}

      <template #popper>
        <p class="mb-1 text-[11px] font-bold uppercase opacity-60">{{ tool.toolName }}</p>
        <pre class="max-h-80 max-w-sm overflow-auto whitespace-pre text-[11px] leading-relaxed">{{ formatInvokedTool(tool) }}</pre>
      </template>
    </DebugBadge>
  </div>
</template>
